import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    UPDATE_OPTION,
    UPDATE_OPTION_SUCCESS,
    UPDATE_OPTION_ERROR,
}
    from "../../../actions/menu/options";

function* updateOptionSaga(action) {
    try {
        const data =  yield call(optionService.UpdateOption, action.payload)
        yield put({
            type: UPDATE_OPTION_SUCCESS,
            payload: data
        });


    } catch (error) {
        yield put({
            type: UPDATE_OPTION_ERROR,error: error.data
        });
    }
}


export function* updateOptionSagaWatcher() {
    yield takeLatest(UPDATE_OPTION, updateOptionSaga);
}